<template>
  <div class="settings">
    <div class="col-12">
      <h3>Category Criteria</h3>
      <p class="mb-4">
        Please select a category you would like to set criteria for.
      </p>
      
      <category-selection-inputs-form
        ref="categorySelectionInput"
        :on-select-department="onSelectDepartment"
        :on-select-category="onSelectCategory"
      />

      <hr v-if="category">

      <category-criteria-display
        ref="categoryCriteriaDisplay"
        :category="category"
      />
    </div>
  </div>
</template>

<script>
import CategorySelectionInputsForm from '@/components/forms/CategorySelectionInputsForm.vue';
import CategoryCriteriaDisplay from '@/components/CategoryCriteriaDisplay.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'AccountCriteria',
  components: {
    CategorySelectionInputsForm,
    CategoryCriteriaDisplay,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
    };
  },
  computed: {
    department() {
      if (this.$refs.categorySelectionInput) {
        return this.$refs.categorySelectionInput.department || '';
      }
      return '';
    },
    category() {
      if (this.$refs.categorySelectionInput) {
        return this.$refs.categorySelectionInput.category || 0;
      }
      return 0;
    },
  },
  mounted() {
    if (this.$route.query.category_id) {
      const category_id = parseInt(this.$route.query.category_id);
      if (this.$refs.categoryCriteriaDisplay) {
        this.$refs.categoryCriteriaDisplay.reset(category_id);
      }

      this.userClient.getCategory(category_id).then(category => {
        if (this.$refs.categorySelectionInput) {
          this.$refs.categorySelectionInput.reset(category.department, category);
        }
      }).catch(ex => {

      });
    }
  },

  methods: {
    onSelectDepartment() {
      // todo: block change with pending changes.. ?
      if (this.$refs.categoryCriteriaDisplay) {
        this.$refs.categoryCriteriaDisplay.reset(0);
      }

      if (this.$refs.customCriteriaForm) {
        this.$refs.customCriteriaForm.reset();
      }
    },
    onSelectCategory(category) {
      // todo: block change with pending changes.. ?
      if (this.$refs.categoryCriteriaDisplay) {
        this.$refs.categoryCriteriaDisplay.reset(category);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
